import { useState } from "react";
import Box from "@mui/material/Box";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import IconButton from "@mui/material/IconButton";
import fileDownload from "js-file-download";
import axios from "../../../../utils/fvAxios";
import BaseURL from "../../../../utils/base-uri.json";
import CircularProgress from "@mui/material/CircularProgress";
import "./Attachment.css";
import { toast } from "react-toastify";

const formatFileSize = function (bytes) {
  const sufixes = ['B', 'kB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  return `${(bytes / Math.pow(1024, i)).toFixed(2)} ${sufixes[i]}`;
};
const Attachment = ({
  message,
  createdOn,
  attachmentName,
  className,
  attachmentSize,
  attachmentId,
}) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const downloadFile = (attachmentFileId, attachmentFileName) => {
    setIsDownloading(true);
    axios
      .get(
        BaseURL.baseUrl +
        "PQCommunication/DownloadAttachment?attachmentId=" +
        attachmentFileId,
        {
          responseType: "blob",
        }
      )
      .then((res) => {
        if (res?.data?.type == "application/json") {
          toast.error("File not found", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else {
          setIsDownloading(false);
          // const blob = new Blob([res.data], { type: res.headers['content-type'] });
          // const blobUrl = URL.createObjectURL(blob);
          // window.open(blobUrl, '_blank');
          // URL.revokeObjectURL(blobUrl);
          const file = new Blob([res.data], { type: "application/pdf" });
          //Build a URL from the file
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.document.write('<iframe width="100%" height="100%" src="' + fileURL + '" frameborder="0" title="YourFileName.pdf" allowfullscreen></iframe>');

        }

        //fileDownload(res?.data, attachmentFileName);
      });
  };
  return (
    <>
      <Box
        className={`${className} w-100 mb-2 align-items-center p-2 d-flex gap-2`}
      >
        <Box className="p-2 custom-bg-light rounded-circle">
          <Box className="rounded-circle p-2 custom-icon-bg">
            <InsertDriveFileOutlinedIcon
              style={{
                color: "inherit",
              }}
            />
          </Box>
        </Box>
        <Box className="w-100">
          <Box className="text-black">{attachmentName}</Box>
          <Box className="d-flex align-items-center gap-2 justify-content-between w-100">
            <div className="text-uppercase text-muted">{formatFileSize(attachmentSize)}</div>
            {isDownloading ? (
              <Box sx={{ display: "flex" }}>
                <CircularProgress />
              </Box>
            ) : (
              <IconButton
                className="btn btn-primary"
                onClick={downloadFile.bind(this, attachmentId, attachmentName)}
              >
                <DownloadOutlinedIcon />
              </IconButton>
            )}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Attachment;
